export class PaymentDocument {
    PaymentDocumentId: number;
    PaymentTermId: number;
    CustomerId: number;
    DocumentType: string;
    DocumentName: string;
    DocumentPath: string;
    DocumentFile: File;
    TDSAmount: number;
}